'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdapterSelect = function AdapterSelect(props) {
  var sortByProperty = props.sortByProperty;
  var options = (props.options || []).slice().sort(function (a, b) {
    if (typeof a[sortByProperty] === 'string') return a[sortByProperty].localeCompare(b[sortByProperty]);
    return parseInt(a[sortByProperty]) - parseInt(b[sortByProperty]);
  });
  return /*#__PURE__*/_react.default.createElement(_index.Select, {
    label: props.label,
    name: props.name || '',
    onChange: props.onChange,
    all: props.pleaseChoose,
    placeholder: props.pleaseChoose,
    allowAll: false,
    value: props.value,
    errors: props.errors,
    list: options,
    readOnly: false,
    t: props.t
  });
};

AdapterSelect.propTypes = {
  t: _propTypes.default.func,
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  options: _propTypes.default.any,
  items: _propTypes.default.any,
  errors: _propTypes.default.any,
  onChange: _propTypes.default.func,
  pleaseChoose: _propTypes.default.string,
  value: _propTypes.default.any,
  sort: _propTypes.default.bool,
  sortByProperty: _propTypes.default.string
};
AdapterSelect.defaultProps = {
  sortByProperty: 'name'
};
var _default = AdapterSelect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/adapter-select.js
// module id = 539
// module chunks = 0